@switch (notification.type) {
  @case (MessageType.modelRevokeConsent) {
    <mat-icon class="notification-icon">contract_delete</mat-icon>
    <div class="notification-message">
      <h6>{{ "notification.model-revoke-title" | translate }}</h6>
      <p class="text-caption-2">
        {{ notification.creationDate | timestamp: "medium" }}
      </p>
      <p>
        {{
          "notification.model-revoke-description"
            | translate
              : {
                  name: model$ | async | modelName,
                  project: (project$ | async)?.name,
                }
        }}
      </p>
    </div>
  }
  @case (MessageType.modelAssetDecline) {
    <mat-icon class="notification-icon">person_remove</mat-icon>
    <div class="notification-message">
      <h6>{{ "notification.model-decline-title" | translate }}</h6>
      <p class="text-caption-2">
        {{ notification.creationDate | timestamp: "medium" }}
      </p>
      <p>
        <img class="asset-image" [src]="imageUrl$ | async" draggable="false" />
        {{
          "notification.model-decline-description"
            | translate
              : {
                  name: model$ | async | modelName,
                  asset: (asset$ | async)?.name,
                }
        }}
      </p>
    </div>
  }
  @case (MessageType.assetDeclined) {
    <mat-icon class="notification-icon">thumb_down</mat-icon>
    <div class="notification-message">
      <h6>{{ "notification.asset-declined-title" | translate }}</h6>
      <p class="text-caption-2">
        {{ notification.creationDate | timestamp: "medium" }}
      </p>
      <p>
        {{
          "notification.asset-declined-description"
            | translate
              : {
                  declineReason: variables["declineReason"],
                }
        }}
      </p>
    </div>
  }
  @case (MessageType.assetForApproval) {
    <mat-icon class="notification-icon">thumb_up</mat-icon>
    <div class="notification-message">
      <h6>{{ "notification.asset-for-approval-title" | translate }}</h6>
      <p class="text-caption-2">
        {{ notification.creationDate | timestamp: "medium" }}
      </p>
      <p>
        {{
          "notification.asset-for-approval-description"
            | translate
              : {
                  user: user$ | async | userName,
                }
        }}
      </p>
    </div>
  }
  @case (MessageType.assetResized) {
    <mat-icon class="notification-icon">aspect_ratio</mat-icon>
    <div class="notification-message">
      <h6>{{ "notification.asset-resized-title" | translate }}</h6>
      <p class="text-caption-2">
        {{ notification.creationDate | timestamp: "medium" }}
      </p>
      <p>
        @if (imageUrl$) {
          <img
            class="asset-image"
            [src]="imageUrl$ | async"
            draggable="false"
          />
        }
        {{
          (multipleVariables
            ? "notification.asset-resized-description-multiple"
            : "notification.asset-resized-description"
          )
            | translate
              : {
                  name: (asset$ | async)?.name,
                }
        }}
        @for (variables of multipleVariables; track variables["assetName"]) {
          <br />{{ variables["assetName"] }}
        }
      </p>
    </div>
  }
}
